

































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import AddEntity from '@/components/Commons/AddEntity.vue';
import PasswordIndicator from '../Login/v2/PasswordIndicator.vue';
import { ChangePasswordRequest,UpdatePasswordRequest } from '../../models/userdata/changepasswordrequest';

@Component({
  name: 'UpdatePassword',
  components: {
    AddEntity,
    PasswordIndicator,
  },
})
export default class UpdatePassword extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private userProfile: UserProfile = new UserProfile();
  private changePassRequest : UpdatePasswordRequest = new UpdatePasswordRequest();
  private userProfileBeforeEdit: UpdatePasswordRequest = new UpdatePasswordRequest();
  private uinewpassword: string = '';
  private uiconfirmnewpassword: string = '';
  private uioldpassword: string = '';
  private newPasswordHidden: boolean = true;
  private confirmNewPasswordHidden: boolean = true;
  private oldPasswordHidden: boolean = true;
  private selectChangePwd: boolean = false;
  private updateButtonDisabled: boolean = true;
  private oldpasswordErrorMsg: string = '';
  private showOldpasswordErrorMsg: boolean = false;

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Watch('userProfile.address1')
  addressChange(newVal, oldVal) {
    this.$emit('disable-next-button', !newVal);
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isSocialMediaSignedInUser() {
    const socialMedias = ['google', 'facebook', 'linkedin'];
    return socialMedias.includes(vxm.users.myUserProfile.sourceType);
  }

  get isProfileDetails() {
    return this.$router.currentRoute.name === 'UpdatePassword';
  }

  onTypingAddress({ newVal = '' } = {}) {
    this.userProfile.address1 = newVal;
  }

  changePassword() {
    this.uioldpassword = '';
    this.uinewpassword = '';
    this.uiconfirmnewpassword = '';
    this.selectChangePwd = true;
    this.showOldpasswordErrorMsg = false;
  }

  mounted() {
    // this.userProfile = vxm.users.myUserProfile;
    this.userProfileBeforeEdit = Object.assign({}, this.changePassRequest);
    console.log("this.userprofile in change password in userprofilebeforeedit",this.userProfileBeforeEdit,"this.change pass request",this.changePassRequest);
    
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  matchPassword() {
    console.info('called');
    if (this.uinewpassword == this.uiconfirmnewpassword) {
      this.updateButtonDisabled = false;
    } else {
      this.updateButtonDisabled = true;
    }
  }

  async saveUserProfile() {
    const vm = this;
    // vm.userProfile.newPassword = this.uinewpassword;
    // vm.userProfile.oldPassword = this.uioldpassword;
    this.changePassRequest.userId = vxm.users.myUserProfile.userId;
    this.changePassRequest.newPassword = this.uinewpassword;
    this.changePassRequest.oldPassword = this.uioldpassword;
    this.changePassRequest.confirmPassword = this.uinewpassword;
    console.log(
      'new password:' +
        vm.userProfile.newPassword +
        ' old password:' +
        vm.userProfile.oldPassword,
    );
    // const respPromise: any = vxm.users.saveUserProfile({
    //   userProfile: this.userProfile,
    //   isPartofRegistration: false,
    // });
    console.log("calling api");
    const respPromise1 : any = await vxm.users.changePassword(this.changePassRequest);
    console.log("new api response",respPromise1);
    Promise.all([respPromise1]).then((values) => {
      console.log("values",values);
      if (!values[0].data.meta.success) {
        console.log('pwd error:' + values[0].errorMessage);
        if (values[0].data.meta.displayMessage == 'Old password entered is wrong') {
          this.oldpasswordErrorMsg = values[0].data.meta.displayMessage;
          this.uinewpassword = '';
          this.uiconfirmnewpassword = '';
          this.selectChangePwd = true;
          this.showOldpasswordErrorMsg = true;
          // vm.userProfile.newPassword = '';
          // vm.userProfile.oldPassword = '';
        } else
          vm.$wlToastr(
            'error',
            values[0].data.meta.displayMessage || vm.$t('changepassword.update.error'),
            vm.$t('profile-accordion.change_password'),
          );
      } else {
        vm.$wlToastr(
          'success',
          vm.$t('changepassword.update.sucess'),
          vm.$t('profile-accordion.change_password'),
        );
        vm.logout();
      }
    });
  }

  cancelChanges() {
    this.selectChangePwd = false;
    // Object.assign(this.userProfile, this.userProfileBeforeEdit);
    Object.assign(this.changePassRequest,this.userProfileBeforeEdit);
  }

  updateChanges() {
    console.log(this.userProfile);
    if (this.validateUserProfileData(this.userProfile)) {
      if (this.validateUserProfileDataOldPassword(this.userProfile)) {
        this.saveUserProfile();
        this.selectChangePwd = false;
      }
    } else {
      this.$wlToastr(
        'error',
        this.$t(this.errorString),
        this.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  saveChanges() {
    console.log(this.userProfile);
    if (this.validateUserProfileData(this.userProfile)) {
      this.saveUserProfile();
    } else {
      this.$wlToastr(
        'error',
        this.$t(this.errorString),
        this.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  validateUserProfileData(userProfile: UserProfile): boolean {
    if (this.selectChangePwd) {
      if (!this.uinewpassword) {
        this.errorString = 'myprofile.newpassword.required';
        return false;
      }
      else {
        const hasNumber = this.uinewpassword.match(/\d+/g);
        const hasLetter = this.uinewpassword.match(/[a-zA-Z]/g);
        const hasUpperCase = this.uinewpassword.match(/[A-Z]/g);
        const hasSpecialCharacter = this.uinewpassword.match(/[*@!#%&()^~{}]+/g);

        if (
          this.uinewpassword.length <
            vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
          (hasNumber == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
          hasLetter == null ||
          (hasUpperCase == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
          (hasSpecialCharacter == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
        ) {
          this.errorString = vxm.utility.passwordConditions;
          return false;
        }
      }
    }
    return true;
  }

  validateUserProfileDataOldPassword(userProfile: UserProfile): boolean {
    if (this.selectChangePwd) {
      if (!this.uioldpassword) {
        this.oldpasswordErrorMsg = String(this.$t('old.password.required'));
        this.showOldpasswordErrorMsg = true;
        return false;
      }
    }
    return true;
  }

  hideNewPassword() {
    this.newPasswordHidden = true;
  }

  showNewPassword() {
    this.newPasswordHidden = false;
  }

  hideConfirmNewPassword() {
    this.confirmNewPasswordHidden = true;
  }

  showConfirmNewPassword() {
    this.confirmNewPasswordHidden = false;
  }

  hideOldPassword() {
    this.oldPasswordHidden = true;
  }

  showOldPassword() {
    this.oldPasswordHidden = false;
  }

  async logout() {
    console.log('user has logged off ....');
    await vxm.users.logout();
    console.log(vxm.users.isLoggedIn);
    this.$router.push({ name: 'Login' });
  }
}
